import { Box, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import FileThumbnail from '../../../../reusable-components/file-thumbnail';

TicketAttachmentThumbnailStack.propTypes = {
  attachments: PropTypes.array,
  setAttachments: PropTypes.func,
}

export default function TicketAttachmentThumbnailStack({ attachments, setAttachments  }) {
  return attachments?.length > 0 ? <Box sx={{ width: '100%' }}>
    <Stack direction="row" alignItems="center" spacing={1}>
      {attachments.map((file) => (
        <FileThumbnail
          key={file.name}
          file={file}
          tooltip
          sx={{ width: 64, height: 64 }}
          wrapperSx={{ position: "relative" }}
          onRemove={() => setAttachments(prevAttachments => prevAttachments.filter((x) => x !== file))}
        />
      ))}
    </Stack>
  </Box> : "";
}
